<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
      <div class="flex mb-1">
        <label for="">{{ $t('status') | capitalize }}</label>
      </div>
      <div class="flex mb-4">
        <v-select
          v-model="filters.status"
          :options="statusList"
          class="w-full"
          :reduce="(status) => status.id"
          label="name"
          multiple
        />
      </div>
    </div>
    <div class="p-4">
      <div class="flex mb-4">
        <vs-checkbox
       v-model="filters.active"
        >
        {{ $t('active_in_vendor_portal') | capitalize }}</vs-checkbox>
      </div>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>
  
  <script>
import loading from '@/mixins/Loading'
import MainSidebar from '@/views/components/MainSidebar.vue'
import vSelect from 'vue-select'

export default {
  components: {
    MainSidebar,
    'v-select': vSelect,
  },
  computed: {
    isSidebarActive: function () {
      return this.$store.state.sidebar === this.name
    },
  },
  data: () => ({
    defaultFilters: {
      status: [],
      active: false,
    },
    filters: {
      status: [],
      active: false,
    },
  }),
  methods: {
    clear: function () {
      this.filters = Object.assign({}, this.defaultFilters)
    },
    close: function () {
      this.$store.dispatch('toggleSidebar', '')
    },
    init: function () {
      this.filters = { ...this.value }
    },
    setFilter: function () {
      this.$emit('input', this.filters)
      this.$emit('search')
      this.close()
    },
  },
  mixins: [loading],
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    statusList:{
      type:Array,
      default: () => []
    },
  },
  watch: {
    isLoading: function (val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    }
  },
}
</script>
  
  <style>
</style>
  